import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

/**
 * TODO:
 */
export const getEntities = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    feature.actions.getEntities.relay(
      (forwardTo, { from, portion, target }) => {
        /**
         * This is the main logic, once we have resolve a value for {@link from}
         */
        function get(actualFrom: NonNullable<typeof from>) {
          return plugin[actualFrom].selectors
            .getFromSelectionLookup(target)
            .asObservable.pipe(
              // NOTE: we just need the latest value (so only one)
              rxjs.take(1),
              rxjs.map(ids =>
                forwardTo(
                  plugin.collection.plugins.dataOperationPlugin.feature.actions
                    .list,
                  {
                    input: { ids: portion === 'first' ? [ids[0]] : ids },
                    output: ({ response }) => response,
                  },
                ),
              ),
            )
        }

        if (from) {
          // When from is defined, we just use it
          return get(from)
        } else {
          // When from is not defined, we need to figure out the appropriate
          // value to use based on the current editing state
          return plugin.feature.selectors
            .isEditing({ target })
            .asObservable.pipe(
              // NOTE: we just need the latest value (so only one)
              rxjs.take(1),
              rxjs.switchMap(isEditing =>
                get(isEditing ? 'edited' : 'applied'),
              ),
            )
        }
      },
    ).asObservable,
)
